import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function SocialProof() {
  return <section className="py-12 border-y border-white/5 bg-white/[0.02]" data-id="element-138">
      <div className="max-w-7xl mx-auto px-6" data-id="element-139">
        <div className="flex flex-col md:flex-row items-center justify-center gap-12 md:gap-24" data-id="element-140">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex items-center gap-4" data-id="element-141">
            <div className="flex flex-col items-center" data-id="element-142">
              <div className="text-3xl font-black" data-id="element-143">4.9</div>
              <div className="flex text-tatan-blue gap-0.5 mt-1" data-id="element-144">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-145" />)}
              </div>
            </div>
            <div className="text-sm text-gray-400 font-medium border-l border-white/10 pl-4" data-id="element-146">
              Over 10k+ ratings
              <br data-id="element-147" />
              on the App Store
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex items-center gap-4" data-id="element-148">
            <div className="text-3xl font-black" data-id="element-149">1M+</div>
            <div className="text-sm text-gray-400 font-medium border-l border-white/10 pl-4" data-id="element-150">
              Tattoos generated
              <br data-id="element-151" />
              by our community
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex items-center gap-8 opacity-50 grayscale" data-id="element-152">
            {/* Stylized fake press logos */}
            <div className="font-black text-xl tracking-tighter" data-id="element-153">INKED.</div>
            <div className="font-serif italic text-xl font-bold" data-id="element-154">Vogue</div>
            <div className="font-black text-xl uppercase tracking-widest" data-id="element-155">
              Wired
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}